import Icon from '../components/Icon';

const CheckCircle = Icon(
  'check-circle',
  <>
    <path
      fillRule="evenodd"
      d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M16.471 8.862c.26.26.26.682 0 .943l-5.333 5.333a.667.667 0 0 1-.943 0L7.53 12.471a.667.667 0 1 1 .942-.942l2.196 2.195 4.862-4.862c.26-.26.682-.26.942 0"
      clipRule="evenodd"
    />
  </>
);

export default CheckCircle;
